window.allowAdd = true
category_count = 0
rule_count = 0
pending_rule_saves = 0

# 'Save' must not submit while an inline rule add is in flight: the row still carries a placeholder id

disable_rule_save = (save_button) ->
  pending_rule_saves += 1
  save_button.prop('disabled', true)

enable_rule_save = (save_button) ->
  pending_rule_saves -= 1 if pending_rule_saves > 0
  save_button.prop('disabled', false) if pending_rule_saves == 0

$(document).ready ->

  $('.add-manager-checklist-rule-button').on('click', (e) ->
    e.preventDefault()
    window.allowAdd = false
    element = ''
    l_ids = $('#language_ids').val().split(',')
    ln_id = $(this).data('language-id')
    m_c_id = $(this).data('manager-checklist-type-id')
    category_name = ''
    category_container = ''
    if m_c_id
      category_name = 'manager-checklist'
      category_container = m_c_id
    $(this).parents('.add-category-container').find('.add-category-input').hide()
    $(this).parents('.add-category-container').find('.add-tip-category-button').hide()
    $(this).parents('.add-category-container').find('.add-category-placeholder').show()
    text = $(this).parents('.add-category-container').find('.add-category-input').val()
    if text.length > 0
      $(this).parents('.add-category-container').find('.add-category-input').val('')

      # Count rows, not language fields: a rule keeps hidden fields for languages dropped from the preset

      count = $(this).parents('form').find('.edit-categories-main-container > .category-item').length + 1

      for l_id in l_ids
        if l_id == ln_id.toString()
          display =  'block'
          textt = text
          span_class = ''
        else
          display = 'none'
          textt = ''
          span_class = 'grayed-out'
        element += "
                    <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                      <span class='category-index-number'>#{count}</span>
                      <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                      <i class='category-order-icon fa fa-bars right active' style='margin-right: -14px;''></i>
                      <input class='edit-category-input' id='rule_#{rule_count}' name='rule[#{rule_count}][name_multi][#{l_id}]' type='text' value='#{textt}'>
                      <button class='edit-category-button display-none'>edit</button>
                    </div>
                  "

      inserted_element = $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('#mdl_rules_checklist .edit-categories-main-container .clearfix')
      rule_count--

      # Step 1. Persist the new rule in the last position

      authentication_token       = $("meta[name=\"csrf-token\"]").attr("content")
      selected_manager_preset_id = $(this).data('selected-manager-preset-id')
      url                        = "/manager_toolkit/rules/add_edit_rule.json"
      selected_language_id       = $(this).data('language-id')
      language_ids               = $("#language_ids").val().split(",")
      name_multi                 = {}

      for language_id in language_ids
        name_multi[language_id] = ""

      name_multi[selected_language_id] = text

      payload                    = {
        authenticity_token: authentication_token,
        selected_manager_preset: selected_manager_preset_id,
        rule: {
          "-1": {"name_multi": name_multi },
        }
      }

      # Step 2. Disable the save button temporarily

      save_button = $(this).parents('form').find('input[type="submit"]')

      disable_rule_save(save_button)

      $.post(url, payload).done((data) ->
        # Step 3. Add the filter modal for the newly persisted rule

        href      = "/manager_toolkit/rules/#{data.id}/rule_filter_modal?selected_manager_preset=#{selected_manager_preset_id}"
        element_a = "<a class='fa fa-filter modal-for-profile-tag' style='color: #9e9e9e; padding-top: 8px; margin-left: 2px' data_link='#category-tag' data-remote='true' href='#{href}'></a>"
        element_i = inserted_element.find("i")

        # Step 4. Rewrite the inserted row's inputs to the real id before 'Save' can see them

        inserted_element.find(".edit-category-input").each (_, input) ->
          l_id = $(input).attr("name").match(/\[name_multi\]\[(\d+)\]/)[1]
          $(input).attr("name", "rule[#{data.id}][name_multi][#{l_id}]").attr("id", "rule_#{data.id}")

        # Step 5. Change the sequence number of the inserted row

        inserted_element.find(".order-item-name")
          .attr("data-id", data.id)
          .attr("data-delete-item-name", "rule")
          .attr("data-url", "/manager_toolkit/rules/#{data.id}?selected_manager_preset=#{selected_manager_preset_id}")
          .data("id", data.id)

        # Step 6. Add the inserted row and make sure that the filters are clickable

        $(element_a)
          .on("click", -> $($(this).attr("data_link")).openModal())
          .insertAfter(element_i)
      ).fail((error) ->
          console.log "Failed to add new rule"
      ).always(->
        enable_rule_save(save_button)
      )
  )
  $('.add-manager-checklist-category-button').on('click', (e) ->
    e.preventDefault()
    window.allowAdd = false
    element = ''
    l_ids = $('#language_ids').val().split(',')
    ln_id = $(this).data('language-id')
    m_c_id = $(this).data('manager-checklist-type-id')
    category_name = ''
    category_container = ''
    if m_c_id
      category_name = 'manager-checklist'
      category_container = m_c_id
    $(this).parents('.add-category-container').find('.add-category-input').hide()
    $(this).parents('.add-category-container').find('.add-tip-category-button').hide()
    $(this).parents('.add-category-container').find('.add-category-placeholder').show()
    text = $(this).parents('.add-category-container').find('.add-category-input').val()
    if text.length > 0
      $(this).parents('.add-category-container').find('.add-category-input').val('')
      count = parseInt(($(this).parents('form').find('.category-index-number').length / $(this).parents('form').find('#language_ids').val().split(',').length) + 1)
      for l_id in l_ids
        if l_id == ln_id.toString()
          display =  'block'
          textt = text
          span_class = ''
        else
          display = 'none'
          textt = ''
          span_class = 'grayed-out'
        element += "
                    <div class='edit-category-container multi-lanuage-field #{category_name}-category-#{category_container}-#{l_id}' style='display: #{display};'>
                      <span class='category-index-number'>#{count}</span>
                      <span data-name='#{textt}' data-delete='false' class='order-item-name #{span_class}'>#{text}</span>
                      <i class='category-order-icon fa fa-bars right active'></i>
                      <input class='edit-category-input' id='category_#{category_count}' name='category[#{category_count}][category_multi][#{l_id}]' type='text' value='#{textt}'>
                      <button class='edit-category-button display-none'>edit</button>
                    </div>
                  "
      $("<div class='category-item ui-sortable-handle'>#{element}</div>").insertBefore('#mdl_categories_checklist .edit-categories-main-container .clearfix')
      category_count--
  )
